
import React from "react";
import { useNavigate } from "react-router-dom";

// MUI + MD Components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function YouTubeResponse({ status, error }) {
  const navigate = useNavigate();

  const goToDashboard = () => navigate("/dashboard");

  const getMessage = () => {
    switch (status) {
      case "no-channel":
        return {
          title: "No YouTube Channel Found ❌",
          color: "error",
          body1:
            "You signed in using a Google account that does not have a YouTube channel.",
          body2:
            "Please select your YouTube Brand Channel instead of your email account.",
          button: "Return to Dashboard",
          buttonColor: "accent",
        };

      case "success":
        return {
          title: "YouTube Connected Successfully 🎉",
          color: "info",
          body2: "Your YouTube channel is now linked to Comparedly.",
          button: "Go to Dashboard",
          buttonColor: "accent",
        };

      case "cancelled":
        return {
          title: "YouTube Connection Cancelled ⚠️",
          color: "info",
          body2:
            "You closed the window or cancelled the permission request.",
          button: "Return to Dashboard",
          buttonColor: "accent",
        };

      default:
        if (error) {
          return {
            title: "YouTube Authentication Error ❌",
            color: "error",
            body2: `Error: ${error}`,
            button: "Try Again",
            buttonColor: "error",
          };
        }

        return {
          title: "YouTube Connection Failed ❌",
          color: "error",
          body2: "We couldn't connect your YouTube account.",
          button: "Try Again",
          buttonColor: "error",
        };
    }
  };

  const msg = getMessage();

  return (
    <MDBox pt={8} pb={6}>
      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Card>
            <MDBox textAlign="center" p={4}>
              {/* Title */}
              <MDTypography
                variant="h3"
                fontWeight="bold"
                gutterBottom
                color={msg.color}
              >
                {msg.title}
              </MDTypography>

              {/* Body Text 1 */}
              {msg.body1 && (
                <MDTypography variant="body1" mt={2}>
                  {msg.body1}
                </MDTypography>
              )}

              {/* Optional Body Text 2 */}
              {msg.body2 && (
                <MDTypography variant="body2" mt={1} color="text">
                  {msg.body2}
                </MDTypography>
              )}

              {/* Button */}
              <MDBox mt={4}>
                <MDButton
                  variant="contained"
                  color={msg.buttonColor}
                  onClick={goToDashboard}
                >
                  {msg.button}
                </MDButton>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default YouTubeResponse;
